import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(private httpClient: HttpClient) { }

  findAll(): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `notification`);
  }


  update(id: string): Observable<any> {
    
    return this.httpClient
      .put(this.API_SERVER + `notification/${id}`, { has_read: true });
  }

  findGeneralNotifications(): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `audit-trails`);
  }
}